export default {"src":"/_next/static/media/arrow_prev_gallery_slide_desktop.1b9779b1.svg","height":14,"width":9};